import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/shop/ProtectedRoute";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const next = sessionStorage.getItem("mr_next") || "/account";
    sessionStorage.removeItem("mr_next");
    api.post("/auth/google/session", { session_id: sid })
      .then(({ data }) => {
        setUser(data);
        toast.success(`Benvenuto, ${data.name}!`);
        navigate(next, { replace: true });
      })
      .catch((e) => {
        toast.error(formatApiError(e));
        navigate("/accedi", { replace: true });
      });
  }, [location.hash, navigate, setUser]);

  return <Loader />;
}
